import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { loadUserAction } from './redux/actions/auth';
import { loadEventsAction } from './redux/actions/event';
import { loadLanguagesAction, loadTranslationSections } from './redux/actions/language';
import { loadConfig } from './redux/actions/config';
import moment from 'moment-timezone';
import Moment from 'react-moment';

const AdminLoader = (props) => {

    useEffect(() => {
        props.dispatch(loadConfig());
        props.dispatch(loadUserAction());

        // Dates will start from Monday instead of Sunday
        moment.locale('en', { week: { dow: 1 } });
        // Moment default/global timezone
        moment.tz.setDefault('Etc/UTC');
        // React moment global configuration
        Moment.globalMoment = moment;
        Moment.globalLocale = 'en';
        Moment.globalTimezone = 'Etc/UTC';
        Moment.globalFormat = "DD MM YYYY";
        Moment.globalLocal = true;
    }, []);

    useEffect(() => {

        if (props.isAuthenticated) {
            props.dispatch(loadEventsAction());
            props.dispatch(loadLanguagesAction());
            props.dispatch(loadTranslationSections());
        }

    }, [props.user]);

    const loaded = props.isAuthenticated ? props.eventLoaded : props.userLoaded;

    return (
        <Loader loadedClassName="loaded-content mh-100 w-100" loaded={loaded}>
            {props.children}
        </Loader>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    isAuthenticated: state.auth?.isAuthenticated,
    userLoaded: state.auth?.loaded,
    eventLoaded: state.event?.loaded,
});

export default connect(mapStateToProps)(AdminLoader);
